// extracted by mini-css-extract-plugin
module.exports = {"table_overige_inkomsten":"overige-inkomsten-modal_table_overige_inkomsten__2EI_7","table_input":"overige-inkomsten-modal_table_input__1PUey"};